import * as React from "react"

// Preserva o breakpoint operacional do shell existente: abaixo de 980px a
// navegação precisa liberar a largura inteira para tabelas e formulários.
const MOBILE_BREAKPOINT = 981

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    // TUT-260 — `matchMedia` pode não existir: o jsdom dos testes não o
    // implementa, e o hook derrubava a árvore inteira ao primeiro componente
    // que o usasse fora do navegador. O produto já se defendia assim em três
    // lugares (`DashboardGrid`, `KanbanPage`, `useThemePreference`); a guarda
    // subiu para cá, que é por onde todos passam — conserto na origem custa
    // uma linha, e em cada chamador custaria uma por chamador.
    if (typeof window.matchMedia !== "function") {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
      return
    }
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}
